import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Achievements from './Achievements';
import HeroSection from './HeroSection';
import Card from './Card';
import Owl from './Owl';
import Services from './Services';
import Technologies from './Technologies';
import { Helmet } from 'react-helmet';

const TextToSpeech = (props) => {
    const { slug } = useParams()
    // =========================== scroll To Top default =========================
    useEffect(() => {
        props.demo('top')
    }, [slug])
    // =========================== scroll To Top default =========================
    return (
        <>
            <Helmet>
                <title>Text to Speech – Infograins</title>
                <meta name="description" content="Infograins is your all-in-one partner for text to speech technology. We will help you from initial stage to the integration support." />
            </Helmet>
            <HeroSection />
            <Achievements />
            <Services />
            <Technologies />
            {/* <Owl /> */}
            <Card />
        </>
    )
}

export default TextToSpeech